import React, { useState } from 'react';
import styled from 'styled-components';
import { InfoIcon } from '@primer/octicons-react';
import { LTText, LTTooltip } from '@lambdatestincprivate/lt-components';

// Ported from analytics MetricTile (Tailwind -> styled-components).
const Tile = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  min-height: 80px;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
  padding: 12px 0;
  padding-left: 16px;
  background: #ffffff;
  border: 1px solid #d0d7de;
  border-radius: 8px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const InfoSpan = styled.span`
  display: inline-flex;
  align-items: center;
  cursor: default;
  color: #57606a;
  transition: opacity 0.15s ease;
  opacity: ${({ $hovered }) => ($hovered ? 0.6 : 0)};
  &:hover {
    opacity: ${({ $hovered }) => ($hovered ? 1 : 0.6)};
  }
`;

const ValueRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 4px;
`;

const MetricTile = ({ title, value, tooltip, valueColor }) => {
  const [hovered, setHovered] = useState(false);
  // A real numeric 0 stays "0"; a missing value (still loading) renders as a dash, not a fake 0.
  const displayValue =
    typeof value === 'number' ? value.toLocaleString() : value ?? '-';

  return (
    <Tile>
      <TitleRow onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
        <LTText text={title} color="#636C76" variant={LTText.TextVariant.SUBHEADER_BOLD} />
        {tooltip && (
          <LTTooltip text={tooltip} direction="bottom">
            <InfoSpan $hovered={hovered} aria-label={`${title} info`}>
              <InfoIcon size={12} />
            </InfoSpan>
          </LTTooltip>
        )}
      </TitleRow>
      <ValueRow>
        <LTText
          text={displayValue}
          style={{ fontSize: '20px', fontWeight: 600, color: valueColor || '#24292F' }}
        />
      </ValueRow>
    </Tile>
  );
};

export default MetricTile;
